<template>
  <div class="Child">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button
          @click="
            listQuery.pageNum - 1;
            shipmentlist();
          "
        >
          查询
        </el-button>
        <el-button @click="clearRadioRowEevnt"> 取消选中 </el-button>
        <el-button type="primary" @click="getRadioEvent"> 获取选中 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="500"
      border
      :loading="loading"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          min-width="150"
          title="用户类型"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'partyType')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" min-width="150" title="用户名称" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" min-width="150" title="用户电话" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="accountId" min-width="250" title="商户id" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.accountId"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantType"
          min-width="150"
          title="商户类型"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'merchantType')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.merchantType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in merchantTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantName"
          min-width="150"
          title="商户名称"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { queryRechargeMerchant } from "@/api/merchantCenter";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        partyType: "",
        name: "",
        phone: "",
        accountId: "",
        merchantType: "",
        merchantName: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      tableData: [],
      merchantTypeOptions: [
        {
          value: "1",
          label: "企业商户"
        },
        {
          value: "2",
          label: "个体商户"
        },
        {
          value: "3",
          label: "自然人"
        }
      ],
      partyTypeOptions: [
        {
          value: "SHIPMENT",
          label: "个体托运人"
        },
        {
          value: "SHIPMENT_COMPANY",
          label: "企业托运人"
        },
        {
          value: "PLAT_ADMIN",
          label: "平台管理员"
        }
      ]
    };
  },
  created() {
    this.shipmentlist();
  },
  methods: {
    shipmentlist() {
      this.loading = true;
      queryRechargeMerchant(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.Pagingconf =
          response.data.total > 10000
            ? [20, 30, 50, 100, 10000]
            : [20, 30, 50, 100, response.data.total || 1];
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    //获取选中
    getRadioEvent() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (!this.getdata) {
        this.$message({ message: "请选择充值商户", type: "warning" });
        return false;
      }
      this.$emit("event1", this.getdata);
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    }
  }
};
</script>
